const API_BASE = `${process.env.REACT_APP_URL || ''}/info_kiosk/scheme`;

export const fetchViewerTree = async () => {
  const r = await fetch(`${API_BASE}/objects/tree`);
  if (!r.ok) throw new Error('Ошибка загрузки дерева');
  return r.json();
};

export const fetchViewerObject = async (id) => {
  const r = await fetch(`${API_BASE}/objects/${id}`);
  if (!r.ok) throw new Error('Ошибка загрузки объекта');
  return r.json();
};

export const getViewerOriginalUrl = (id) => `${API_BASE}/objects/${id}/image/original`;
export const getViewerPreviewUrl = (id) => `${API_BASE}/objects/${id}/image/preview`;
